import type { Category } from "../../domain/entities.ts";

export interface CollectionActionOptions {
  editable: boolean;
  owner: boolean;
  favorite: boolean;
  boardView?: boolean;
  icon(name: string): string;
}

/** One permission-aware action list, shared by sidebar and collection heading. */
export function collectionActionItems(category: Category, options: CollectionActionOptions): string {
  const { editable, owner, favorite, icon } = options;
  const item = (action: string, glyph: string, label: string, extra = "") => `<button role="menuitem" data-action="${action}" data-id="${category.id}" ${extra}>${icon(glyph)} ${label}</button>`;
  const groups = [
    item("toggle-favorite-destination", "star", favorite ? "Remove from favorites" : "Add to favorites", `data-destination-kind="collection" data-root-id="${category.rootId}"`),
    options.boardView && category.boardColumns?.length ? item("collapse-other-board-columns", "chevron", "Collapse other columns") + item("expand-board-columns", "list", "Expand all columns") : "",
    owner ? item("share-category", "users", "Share collection") : "",
    editable ? [
      item("edit-category", "edit", "Edit collection settings"),
      `<button type="button" role="menuitem" data-collection-intake="${category.id}">${icon("plus")} Intake form and requests</button>`,
      item("duplicate-category", "copy", "Duplicate collection"),
      item("archive-category", "archive", "Archive collection"),
    ].join("") : "",
    owner ? item("delete-category", "trash", "Delete collection", 'class="is-danger"') : "",
  ].filter(Boolean);
  return groups.map(group => `<div role="group" class="context-action-group">${group}</div>`).join("");
}
